module.exports = __webpack_public_path__ + "img/Butterfly_00025.6e8803c9.png";